import InteractiveCatalogIndexPage from '../../model/interactive/InteractiveCatalogIndexPage';

export default class InteractiveCatalogIndexPageParser {

    static parse(node) {
        let interactiveCatalogIndexPage = new InteractiveCatalogIndexPage();

        interactiveCatalogIndexPage.horizontalIndexImage = node.children('ns2\\:horizontalIndexImage').text();
        interactiveCatalogIndexPage.verticalIndexImage = node.children('ns2\\:verticalIndexImage').text();
        interactiveCatalogIndexPage.numPage = parseInt(node.children('ns2\\:numPage').text());
        interactiveCatalogIndexPage.title = node.children('ns2\\:title').text();
        interactiveCatalogIndexPage.description = node.children('ns2\\:description').text();

        return interactiveCatalogIndexPage;
    }

}
